import { useCallback, useMemo } from "react";
import { SubscriptionOrgStyled } from "pages/subscription/SubscriptionStyled";
import SelectComponent from "components/atoms/select/SelectComponent";
import { suspendOptions } from "utils/options";
import { changeSuspensionStatus, checkIsSuspended } from "utils/AccountUtil";
import { SuspendedPayload } from "api/interfaces/accountInterface.interface";

interface SuspendData {
  isSuspended: number;
  cascadedSuspension: number;
  accountId: string;
}
export default function SuspendButton({
  data,
  isDisabled,
  onChangeStatus,
}: {
  data: SuspendData;
  isDisabled?: boolean;
  onChangeStatus: (payload: Omit<SuspendedPayload, "accountId">) => void;
}) {
  const options = useMemo(
    () =>
      suspendOptions.map((option) => ({
        label: option.label,
        value: option.value.toString(),
      })),
    []
  );
  const onSelectValue = useCallback(
    (value: string) => {
      if (value === checkIsSuspended(data).toString()) return;
      onChangeStatus({
        suspensionStatus: Number(value),
        targetAccountId: data.accountId,
      });
    },
    [data, onChangeStatus]
  );

  return (
    <SubscriptionOrgStyled.SuspendBox className="suspend-button">
      <SelectComponent
        onChange={onSelectValue}
        options={options}
        disabled={data.cascadedSuspension > 0 || isDisabled}
        value={
          options.find(
            (option) =>
              changeSuspensionStatus(Number(option.value)) ===
              checkIsSuspended(data)
          )?.value
        }
        data-testid="subscription-organization-list-selects-select-value"
      />
    </SubscriptionOrgStyled.SuspendBox>
  );
}
